export enum TourActions {
  initialize = 'initialize',
  start = 'start',
  next = 'next',
  back = 'back',
  complete = 'complete',
}
